export enum OperationEnum {
  ADD = "ADD",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
}

export type ErrorItem = {
  code: string;
  message: string;
};

export type SingleErrorResponse = ErrorItem;

export type MultipleErrorResponse = ErrorItem[];

export interface Pagination {
  total: number;
  pageNumber: number;
  pageSize: number;
}

export type PaginatedBody<T> = {
  data: T[];
  pagination: Pagination;
};

export type QueryParam = {
  key: string;
  value: (string | number | boolean)[];
};

export type ResourceId = {
  id: number;
};

export type BatchOperation<T> = {
  operation: OperationEnum;
  entityId: number | null;
  data: Partial<T> | null;
};
